module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-33-a2512a40af1572eb1a03ba17d8e8d73f.svg";